export const PriceDisplay = ({ amount, showPrefix = false }) => {
    if (!amount) return '$0';
    
    // Handle string amounts like "$10.00" or numeric amounts
    const numericAmount = typeof amount === 'string' 
        ? parseFloat(amount.replace('$', '')) 
        : amount;
    
    // Show FREE for zero amounts
    if (numericAmount === 0) {
        return 'FREE';
    }
    
    // Format the price
    const formatted = numericAmount.toFixed(2);
    
    // Remove cents if they are .00
    const displayPrice = formatted.endsWith('.00') 
        ? `$${Math.round(numericAmount)}` 
        : `$${formatted}`;
    
    return showPrefix ? `- ${displayPrice}` : displayPrice;
};